import AbstractApi from '@/api/abstracts/AbstractApi'
import httpClient from '@/utilities/service/httpClient'
import { ProjectFeePayloadType } from '@/api/types/request/ProjectFeePayloadType'
import { ProjectFeeType } from '@/api/types/response/ProjectFeeType'

/**
 * @property string apiEnd /api/sales/project/overview/{BidNumber}/adjustment
 */
export default class ProjectFeeApi extends AbstractApi {
  add(payload: ProjectFeePayloadType): Promise<ProjectFeeType> {
    return httpClient.post(this.apiEnd, payload)
  }

  delete(payload: ProjectFeePayloadType): Promise<ProjectFeeType> {
    return httpClient.delete(this.apiEnd, { data: payload })
  }
}
